// ------------- OPTIONS -------------

export const animation = {
  default: '.35s ease-in-out'
}

export const breakpoints = {
  b1: '500px',
  b2: '501px',
  b3: '900px',
  b4: '901px',
  b5: '1200px',
  b6: '1201px',
  b7: '1400px',
}

export const colors = {
  black: {
    b1: '#000000',
    b2: '#0d0d0d',
  },
  blue: {
    b1: '#487af2',
    b2: '#8aabf9',
  },
  grey: {
    g1: '#1b1b1b',
    g2: '#272727',
    g3: '#a8a8a8',
    g4: '#e5e5e5'
  },
  red: '#ff3a25',
  white: '#ffffff',
};

export const colorsOpaque = {
  c1: 'rgba(0, 0, 0, .7)',
  c2: 'rgba(35, 35, 35, 0.8)',
  c3: 'rgba(255, 255, 255, .05)',
}

export const radius = {
  r1: '.25rem',
}

export const typography = {
  lineHeight: {
    lh1: '1.25',
    lh2: '1',
  },
  size: {
    f1: '2.6rem',
    f2: '2.4rem',
    f3: '1.8rem',
    f4: '1.6rem',
    f5: '1.5rem',
    f6: '1.4rem',
    f7: '1.2rem',
  },
  type: {
    lovelo: '"lovelo", sans-serif',
    opensans: '"Open Sans", sans-serif',
  },
  weight: {
    w1: '800', // black
    w2: '700', // bold
    w3: '400', // regular
  }
}


// ------------- DECISIONS -------------

export const mainTheme = {
  backgroundColor: {
    accent: colors.blue.b1,
    accordion: {
      btnHover: colors.black.b2
    },
    body: colors.grey.g1,
    button: {
      critical: colors.red,
      primary: colors.blue.b1,
      primaryHover: colors.white,
    },
    createProjectPlaceholder: colorsOpaque.c3,
    critical: colors.red,
    dropzone: {
      default: colorsOpaque.c3,
      hover: colorsOpaque.c2,
    },
    footer: colorsOpaque.c1,
    locationModal: {
      modal: colors.grey.g1,
      preview: colors.grey.g2,
    },
    modal: colors.grey.g2,
    sidebar: colors.black.b1,
    tag: colors.blue.b1,
    tile: {
      default: colorsOpaque.c2,
      hover: colorsOpaque.c3,
    },
    toolbar: colors.grey.g1,
  },

  border: {
    accent: colors.blue.b1,
    accordion: colors.grey.g3,
    datePaginator: colors.black.b1,
    dropzone: colors.grey.g3,
    input: {
      active: colors.grey.g4,
      default: colors.grey.g3,
    },
    locationModal: colors.grey.g3,
  },

  borderRadius: {
    default: radius.r1,
  },

  breakpoints: {
    mobile: breakpoints.b1,
    tablet: breakpoints.b3,
    tabletMin: breakpoints.b2,
    laptop: breakpoints.b5,
    laptopMin: breakpoints.b4,
    desktop: breakpoints.b7,
    desktopMin: breakpoints.b6,
  },

  font: {
    accent: typography.type.lovelo,
    default: typography.type.opensans,
    lineHeight: {
      default: typography.lineHeight.lh1,
      small: typography.lineHeight.lh2,
    },
    size: {
      heading: {
        h1: typography.size.f1,
        h2: typography.size.f1,
        h3: typography.size.f5,
      },
      button: {
        default: typography.size.f3,
        medium: typography.size.f4,
        small: typography.size.f6,
      },
      icon: typography.size.f2,
      input: typography.size.f3,
      text: {
        default: typography.size.f3,
        small: typography.size.f6,
        extrasmall: typography.size.f7,
      },
    },
    weight: {
      black: typography.weight.w1,
      bold: typography.weight.w2,
      regular: typography.weight.w3,
    }
  },

  textColor: {
    accent: colors.blue.b1,
    critical: colors.red,
    default: colors.white,
    input: {
      error: colors.red,
      placeholder: colors.grey.g3,
    },
    link: {
      critical: colors.red,
      default: colors.blue.b1,
    },
    secondary: colors.grey.g3,
  },

  transition: {
    default: animation.default,
  }
}
